import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { WidgetCard } from '@/shared/ui';

import { usePatientRecordingsCard } from '../../hooks';
import { PatientRecordingsItem } from '../PatientRecordingsItem';

import styles from './PatientRecordingsCard.module.scss';

type PatientRecordingsCardProps = {
  patientID: string;
  className?: string;
};

export const PatientRecordingsCard: FC<PatientRecordingsCardProps> = ({
  patientID,
  className,
}) => {
  const { formatMessage, formatNumber } = useIntl();
  const {
    previewConsultations,
    visibleTotal,
    isVisible,
    userTimezone,
    isConsultationStale,
    forceStop,
    handleCardClick,
    handleItemClick,
  } = usePatientRecordingsCard(patientID);

  if (!isVisible) {
    return null;
  }

  return (
    <WidgetCard
      data-component="patient-recordings-card"
      className={cn(styles.container, className)}
      onClick={handleCardClick}
    >
      <div className={styles.header}>
        <h4 className={cn('h4', styles.title)}>
          {formatMessage({
            id: 'patientRecordings.title',
            defaultMessage: 'Recordings',
          })}
        </h4>
        {visibleTotal > 0 && (
          <span className={cn('h5', styles.count)}>
            {formatNumber(visibleTotal)}
          </span>
        )}
      </div>

      <div className={styles.list}>
        {previewConsultations.map((consultation) => (
          <PatientRecordingsItem
            key={consultation.id}
            consultation={consultation}
            userTimezone={userTimezone}
            isStale={isConsultationStale(consultation)}
            onClick={handleItemClick}
            onForceStop={forceStop}
          />
        ))}
      </div>

      <span className={cn('p2', styles.showAll)}>
        {formatMessage({
          id: 'patientRecordings.showAll',
          defaultMessage: 'Show all recordings',
        })}
      </span>
    </WidgetCard>
  );
};
